import { DocumentCard, DocumentCardImage, Icon, ImageFit } from '@fluentui/react';
import * as React from 'react';
import { shareUrl } from '../../../../constants/url.constant';
import { addCartFunc } from '../../../carts/views/CartView';
import { Utils } from '../../../common/views/Utils';
import { ProductKeyModel, ProductSearchOption, ShortLineModel } from '../../models/ProductModel';
import { ProductUtils } from '../../ProductUtils';
import ProductPriceView from './ProductPriceView';

export type AdminProductItemProps = {
    line: ShortLineModel;
    onDetail: (key: ProductKeyModel) => void;
    onBarcode: (barcode: string) => void;
    isAdmin: boolean;
    isMobile: boolean;
    addToCart: addCartFunc;
    setFavorite: (lineId: number, isDeleted: boolean) => void;
}

export default function AdminProductItemView({
    line, onDetail, onBarcode, isAdmin, isMobile, addToCart, setFavorite
}: AdminProductItemProps) {
    let url = ProductUtils.getImageUrl(line.imageUrl);

    const model = {
        groupId: line.groupId,
        lineId: line.id,
        productId: line.productId
    } as ProductKeyModel;

    const padding = isMobile ? "ph-5" : "ph-15";
    const vSpacing = isMobile ? "pt-5" : "pt-10";

    //const printPrice = () => {
    //    const info = line.printInfo;

    //    if (line.minPrice !== line.maxPrice) {
    //        return <>${line.minPrice} - ${line.maxPrice}</>
    //    } else {
    //        return <>
    //            {!Utils.isNullOrEmpty(info.price) && <span>${info.price}</span>}

    //            {!Utils.isNullOrEmpty(info.originalPrice) && <>
    //                <span className="pl-10 firmed" style={{ textDecoration: "line-through" }}>
    //                    ${info.originalPrice}
    //                </span>
    //            </>}
    //        </>
    //    }
    //}

    const barcodeButton = () => {
        return <>
            <Icon
                iconName="GenericScan"
                className="pointer"
                style={{ fontSize: "medium" }}
                onClick={() => onBarcode(line.barcodes.replaceAll(",", ""))}
            />
        </>;
    }

    const featureView = () => {
        return <>
            <div className="product-feature left pt-5">
                {isAdmin && <>
                    {line.deleted && <span className="firmed">Deleted</span>}
                    {!line.active && <span className="firmed">Inactive</span>}
                    {!line.approved && <span className="firmed">Not Approved</span>}
                </>}

                {line.newArrival && <span className="accepted">New Arrival</span>}
                {line.choice && <span className="accepted">Choice</span>}
                {line.specialSale && <span className="accepted">Special Sale</span>}
                {line.topRate && <span className="accepted">Top Rate</span>}
                {line.topSale && <span className="accepted">Top Sale</span>}

                {isAdmin && line.activeCount === 1 && !Utils.isNullOrEmpty(line.barcodes) && <>
                    {barcodeButton()}
                </>}
            </div>
        </>;
    }

    const cartButton = () => {
        return <>
            <Icon
                iconName="ShoppingCart"
                className="pointer"
                onClick={() => addToCart(line.productId, 1)}
            />
        </>;
    }

    //const onShare = async () => {
    //    const url = shareUrl + `?type=0&&option=${ProductSearchOption.lineId}&&searchText=${line.id}`;

    //    if (navigator.share) {
    //        try {
    //            await navigator.share({
    //                title: document.title,
    //                text: 'Check this out',
    //                url: url
    //            });
    //        } catch (error) {
    //            console.log('Share cancelled');
    //        }
    //    } else {
    //        await navigator.clipboard.writeText(url);
    //        alert('Link copied!');
    //    }
    //}

    const shareButton = () => {
        return <>
            <Icon
                iconName="Share"
                className="pointer"
                onClick={() => ProductUtils.onShare(line.id)}
            />
        </>
    }

    const favoriteButton = () => {
        return <>
            <Icon
                iconName={line.isFavorite ? "HeartFill" : "Heart"}
                className="pointer"
                onClick={() => setFavorite(line.id, line.isFavorite)}
            />
        </>
    }

    const moreOptionText = () => {
        return <span className="font-small">More Option</span>;
    }

    const actionRow = () => {
        const showCart = line.activeCount === 1 && line.productId > 0;
        const showBarcode = isAdmin && line.activeCount === 1 && !Utils.isNullOrEmpty(line.barcodes);
        const width3 = Utils.getColumnWidth(3);
        const width6 = Utils.getColumnWidth(6);

        return <div className="ms-Grid-row pt-10 pb-5 ml--5 mr--5" style={{ fontSize: "large" }}>
            <div className={width3 + " left"}>
                {!isAdmin && shareButton()}
                {showBarcode && barcodeButton()}
            </div>
            <div className={width6 + " center" + (!showCart ? " mt--5" : "")}>
                {showCart && cartButton()}
                {!showCart && moreOptionText()}
            </div>
            <div className={width3 + " right"}>
                {favoriteButton()}
            </div>
        </div>;
    }

    return <DocumentCard className="picture-wrapper">
        <div className="pointer" onClick={() => onDetail(model)}>
            <DocumentCardImage height={180} imageFit={ImageFit.centerCover}
                className="product-picture image-radius" imageSrc={url} />

            <div className="left font-smaller pt-10">
                <div className={vSpacing + " font-bold"}>{line.brand}</div>
                <div className={vSpacing + " limit-lines one-line"} style={{ opacity: 0.7 }}>
                    {line.productName}
                </div>
                <div className={vSpacing + " font-bold"}>
                    <ProductPriceView
                        info={line.printInfo}
                        minPrice={line.minPrice}
                        maxPrice={line.maxPrice}
                    />
                </div>
            </div>
        </div>

        {actionRow()}
        <hr color="lightGray" style={{ height: 1, border: "none" }} />
    </DocumentCard>;
}